import { IRootState } from '../../../../../store'
import { IPupilsState } from '../store/pupils.types'

export const getPupilsSelector = (state: IRootState): IPupilsState => state.pupils
